// Fragt den aktuell gültigen sechsstelligen TOTP-Code als zweiten Login-Schritt ab.
import React, { useState } from "react";
import { Button, LinearProgress, TextField, Typography } from "@material-ui/core";

const normalizeCode = (value) => value.replace(/\D/g, "").slice(0, 6);

const TotpVerification = ({ processing, error, onSubmit }) => {
	const [code, setCode] = useState("");
	const submit = () => code.length === 6 && onSubmit(code);

	return <>
		<Typography component="h1" variant="h5" align="center">
			Zwei-Faktor-Anmeldung
		</Typography>
		<Typography variant="body2" paragraph>
			Gib den sechsstelligen Code aus deiner Authenticator-App ein.
		</Typography>
		<TextField
			id="totp-verification-code"
			label="Authenticator-Code"
			variant="outlined"
			margin="normal"
			fullWidth
			required
			autoFocus
			autoComplete="one-time-code"
			inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
			value={code}
			onChange={(event) => setCode(normalizeCode(event.target.value))}
			onKeyDown={(event) => {
				if (event.key === "Enter") {
					event.preventDefault();
					submit();
				}
			}}
			disabled={processing}
			error={Boolean(error)}
			helperText={error ? "Der Code ist ungültig oder abgelaufen." : ""}
		/>
		<Button
			variant="contained"
			color="primary"
			size="large"
			fullWidth
			disabled={processing || code.length !== 6}
			onClick={submit}
		>
			Code bestätigen
		</Button>
		{processing && <LinearProgress color="secondary" />}
	</>;
};

export default TotpVerification;
